import styled from 'styled-components'
import Link from '../../../../utils/Link'

export default styled(Link)`
  color: ${props => props.theme.email.full.color};
  text-decoration: underline;
`
